import React from 'react';
import { FeedbackIcon, SatCoreRegister } from 'sat-core';
import iconCommentActive from '../img/icon-comment-active.svg';

export const FeedbackIconOverride = (props) => <FeedbackIcon {...props} icon={iconCommentActive} />;

export default FeedbackIconOverride;

SatCoreRegister('FeedbackIcon', FeedbackIconOverride);
